<template lang="pug">
  SingleLayout(
    :item='true'
    :itemlist='true'
    :showcases='["albums", "artists"]'
  )
    template(
      slot='item'
      v-if='genre'
    )
      Genre(
        type='full'
        :key='genreId'
        :genre='genre'
      )
    template(
      slot='itemlist'
      v-if='genreTracks.length'
    )
      ItemList(
        type='tracks'
        view='list'
        :key='genreId'
        :tracklist='tracklist'
        :items='genreTracks'
      )
    template(
      slot='showcase-albums'
      v-if='genreAlbums.length'
    )
      Showcase(
        :title='$l10n("ALBUMS")'
        type='albums'
        :key='genreId'
        :url='`/genres/${$route.params.id}/albums`'
        :items='genreAlbums'
      )
    template(
      slot='showcase-artists'
      v-if='genreArtists.length'
    )
      Showcase(
        :title='$l10n("ARTISTS")'
        type='artists'
        :key='genreId'
        :url='`/genres/${$route.params.id}/artists`'
        :items='genreArtists'
      )
</template>

<script>
import singlePage from "@/mixins/pages/single.mixin";
import PageLoader from "@/services/pageLoader";
import Showcase from "@/components/Showcase/Showcase";
import Genre from "@/components/Genre/Genre";
import ItemList from "@/components/ItemList/ItemList";
import errorHandler from "@/services/errorHandler";

import { mapGetters } from "vuex";

const strategy = async function(route, ctx) {
  try {
    ctx.genreId = PageLoader.getIdFromRoute(route);

    const { genre } = await PageLoader.getGenre({ id: ctx.genreId });

    route.meta.title = genre.name;
  } catch (error) {
    errorHandler.resolve(error);
  }

  try {
    const { tracks } = await PageLoader.getTracksByGenre({ id: ctx.genreId });
    const { albums } = await PageLoader.getAlbumsByGenre({ id: ctx.genreId });
    const { artists } = await PageLoader.getArtistsByGenre({ id: ctx.genreId });

    ctx.tracksIds = tracks.map(track => track.id);
    ctx.albumsIds = albums.map(album => album.id);
    ctx.artistsIds = artists.map(artist => artist.id);
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "GenrePage",
  mixins: [singlePage(strategy)],
  data() {
    return {
      genreId: null,
      tracksIds: [],
      albumsIds: [],
      artistsIds: []
    };
  },
  computed: {
    ...mapGetters({
      genres: "genres/genres",
      albums: "albums/albums",
      artists: "artists/artists",
      tracks: "tracks/tracks"
    }),
    genre() {
      return this.genres[this.genreId];
    },
    genreTracks() {
      return this.tracksIds.map(id => this.tracks[id]);
    },
    genreAlbums() {
      return this.albumsIds.map(id => this.albums[id]);
    },
    genreArtists() {
      return this.artistsIds.map(id => this.artists[id]);
    },
    tracklist() {
      return {
        id: this.genreId,
        tracks: this.tracksIds
      };
    }
  },
  components: {
    Genre,
    ItemList,
    Showcase
  }
};
</script>
